export const CONTENT_CONTAINER_ELEMENT_ID = 'content-container';
